import { PayloadAction } from '@reduxjs/toolkit';

import { PreviewState, PreviewType } from 'editor/src/store/editorModules/preview/types';

const setActivePreviewReducer = (state: PreviewState, action: PayloadAction<PreviewType | undefined>) => {
  state.activePreview = action.payload;
};

export default setActivePreviewReducer;
